/* eslint-disable no-unused-vars */
import React from 'react';
import {Title, Image, Paragraph, Slideshow} from './../../Basics';
import Particle from './../../Particle';
/* eslint-enable no-unused-vars */

const Particle12 = () => (<div>

  <Title>Tasks arm prosthesis course</Title>
  <Slideshow>
    <section>
      <Image
        source={require('./12_Bild_1_ARM_Team_DIPO-Power_NicolaPitaro_7667.jpg')}
        title='The steady hand task'
        caption={
          <span>
            <b>The steady hand task</b>
             The participants were instructed to guide a ring along a bent wire without touching it.
             A difficult task most competitors were unable to complete.
          </span>
        }
      />
    </section>

    <section>
      <Image
        source={require('./12_Bild_2_ARM_Team_Imperial_NicolaPitaro_7627.jpg')}
        title='The wooden panel puzzle'
        caption={
          <span>
            <b>The wooden panel puzzle</b>
            Various grips attached to the panels had to be grasped with the prosthetic hand.
            Differently shaped grips call for different grasping techniques.
          </span>
        }
      />
    </section>

    <section>
      <Image
        source={require('./12_Bild_3_ARM_Team-Imperial_AlessandroDellaBella_083.jpg')}
        title='The lightbulb challenge'
        caption={
          <span>
            <b>The lightbulb challenge</b>
            Participants were asked to screw a lightbulb into a socket using their prosthetic hand, without crushing the bulb. 
          </span>
        }
      />
    </section>

    <section>
      <Image
        source={require('./12_Bild_4_ARM_Team_Meltin-MMI_NicolaPitaro_7660.jpg')}
        title='Heavy objects'
        caption={
          <span>
            <b>Heavy objects</b>
            Competitors were required to carry a box, a full watering can and a beverage
            case over an obstacle consisting of a series of steps and to deposit the items on a table.
          </span>
        }
      />
    </section>

    <section>
      <Image
        source={require('./12_Bild_5_ARM_Team_SoftHand-Pro_NicolaPitaro_6458.jpg')}
        title='Everyday chores'
        caption={
          <span>
            <b>Everyday chores</b>
            Even cutting a slice of bread or opening a tin are very difficult tasks for individuals
            having to rely on an arm prosthesis. Fotos: ETHZ
          </span>
        }
      />
    </section>
  </Slideshow>

  <Particle
    number={26}
  />

</div>);

export default Particle12;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle12/Particle12_EN.js
 **/